import { Field } from 'react-final-form';

import { ErknmActViolationItems } from 'KnmErknmPackage/ErknmViolationsModule/components/ErknmActViolationItems';
import { ErknmDecisionViolationItems } from 'KnmPackage/KnmViolatedRequirementsNpa/components/ErknmDecisionViolationItems';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmErknmFormViolatedRequirementsMandatory } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { ErknmFieldMark } from 'KnmErknmPackage/MainModule/components/ErknmFieldMark';
import { SelectInputFieldAutoOptions } from 'UIPackage/MainModule/components/SelectInputFieldAutoOptions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';

import styles from './KnmViolatedRequirementsNpaItem.module.scss';
import collapseStyles from '../../MainModule/components/KnmCollapse.module.scss';

interface IKnmViolatedRequirementsMandatoryProps {
  name: string;
  isViolationFieldsWatchOnly: boolean;
  watchOnly: boolean;
  touched?: boolean;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  isMandatoryDisabled: boolean;
  isInsideDecisionsSection?: boolean;
  inAct?: boolean;
  violatedMandatoryName: string;
  index: number;
  mandatoryValue: IKnmErknmFormViolatedRequirementsMandatory;
  handleRemoveMandatory: (index: number) => void;
  correspondingActMandatoryViolations: IKnmErknmFormViolation[];
  isPaperless: boolean;
  mId: string;
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
  disabledByRepeatCheck?: boolean;
  isExpandAll?: boolean;
  extractVersion?: number;
  isProductsResultDecision?: boolean;
}

export const KnmViolatedRequirementsMandatory = ({
  name,
  isViolationFieldsWatchOnly,
  watchOnly,
  touched,
  formRef,
  isMandatoryDisabled,
  isInsideDecisionsSection,
  inAct,
  violatedMandatoryName,
  mandatoryValue,
  index,
  handleRemoveMandatory,
  correspondingActMandatoryViolations,
  isPaperless,
  mId,
  isKnm,
  isPm,
  isDecision,
  disabledByRepeatCheck,
  isExpandAll,
  extractVersion,
  isProductsResultDecision,
}: IKnmViolatedRequirementsMandatoryProps) => {
  const mandatoryFieldName = `${name}.violatedMandatory`;

  return (
    <Field name={`${violatedMandatoryName}.mandatory`}>
      {({ meta }) => (
        <>
          <div className={styles.ViolatedMandatoryWrapper}>
            <div className={styles.ViolatedMandatoryBlock}>
              <div className={styles.Mandatory}>
                <span className={styles.ViolatedMandatoryHeader}>Содержание требования</span>
                {mandatoryValue.mandatory.title}
              </div>
              <div className={styles.Category}>
                <span className={styles.ViolatedMandatoryHeader}>
                  {
                    <>
                      Значимость последствий нарушения
                      <ErknmFieldMark fieldName={`${mandatoryFieldName}[${index}].category`} />
                    </>
                  }
                </span>
                <SelectInputFieldAutoOptions
                  name={`${mandatoryFieldName}[${index}].category`}
                  optionName={CommonCatalogsNamesEnum.MANDATORY_CATEGORIES}
                  disabled={watchOnly || isMandatoryDisabled}
                />
              </div>
              {!watchOnly && !isMandatoryDisabled && (
                <div>
                  <button
                    type="button"
                    className={collapseStyles.DeleteButton}
                    onClick={() => handleRemoveMandatory(index)}
                  >
                    <span className={collapseStyles.DeleteButtonIcon} />
                  </button>
                </div>
              )}
            </div>
            {isInsideDecisionsSection ? (
              <ErknmDecisionViolationItems
                formRef={formRef as IKnmFormRef | undefined}
                watchOnly={watchOnly}
                name={violatedMandatoryName}
                actViolations={correspondingActMandatoryViolations}
                isPaperless={isPaperless}
                mId={mId}
                isDecision={isDecision}
                isKnm={isKnm}
                isPm={isPm}
                isRepeatCheck={disabledByRepeatCheck}
                isExpandAll={isExpandAll}
                extractVersion={extractVersion}
                isProductsResultDecision={isProductsResultDecision}
              />
            ) : (
              <ErknmActViolationItems
                formRef={formRef}
                isAddEnabled={!watchOnly}
                watchOnly={isViolationFieldsWatchOnly}
                name={violatedMandatoryName}
                inAct={!!inAct}
                isPaperless={isPaperless}
                mId={mId}
              />
            )}
          </div>
          {touched && meta.error && <p className="shared-input-error shared-row__small-margin">{meta.error}</p>}
        </>
      )}
    </Field>
  );
};
